import React, { forwardRef } from "react";
import "./Menu.css";
import { clsx } from "../../utils/clsx";

export const MenuItem = forwardRef(({ className, children, variant = "default", ...rest }, ref) => (
  <button
    ref={ref}
    type="button"
    className={clsx("ds-menu__item", variant !== "default" && `ds-menu__item--${variant}`, className)}
    {...rest}
  >
    {children}
  </button>
));
MenuItem.displayName = "MenuItem";

export const Menu = ({ open = true, className, children, role = "menu", ...rest }) => {
  if (open === false) return null;
  return (
    <div className={clsx("ds-menu", className)} role={role} {...rest}>
      {children}
    </div>
  );
};

Menu.Item = MenuItem;

export default Menu;
